import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

const MessagesAdmin = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const q = query(collection(db, "contactMessages"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const msgs = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setMessages(msgs);
      } catch (error) {
        console.error("خطأ في جلب الرسائل:", error);
      }
      setLoading(false);
    };

    fetchMessages();
  }, []);

  return (
    <div style={{ padding: "50px 20px", fontFamily: "Cairo, sans-serif" }}>
      <h2 style={{ textAlign: "center", color: "#004aad", marginBottom: "30px" }}>
        سجل الرسائل
      </h2>

      {loading ? (
        <p style={{ textAlign: "center" }}>جارٍ تحميل الرسائل...</p>
      ) : messages.length === 0 ? (
        <p style={{ textAlign: "center" }}>لا توجد رسائل حتى الآن.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "600px"
          }}>
            <thead>
              <tr style={{ backgroundColor: "#004aad", color: "#fff" }}>
                <th style={thStyle}>الاسم</th>
                <th style={thStyle}>البريد الإلكتروني</th>
                <th style={thStyle}>الرسالة</th>
                <th style={thStyle}>تاريخ الإرسال</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((msg) => (
                <tr key={msg.id} style={{ borderBottom: "1px solid #ccc" }}>
                  <td style={tdStyle}>{msg.name}</td>
                  <td style={tdStyle}>{msg.email}</td>
                  <td style={tdStyle}>{msg.message}</td>
                  <td style={tdStyle}>
                    {msg.createdAt?.toDate ? msg.createdAt.toDate().toLocaleString("ar-EG") : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const thStyle = {
  padding: "12px 15px",
  textAlign: "right",
  fontSize: "1rem"
};

const tdStyle = {
  padding: "10px 12px",
  textAlign: "right",
  fontSize: "0.95rem",
  verticalAlign: "top"
};

export default MessagesAdmin;
